import { render, staticRenderFns } from "./CouponUsed.vue?vue&type=template&id=5c0eef8a&scoped=true&"
import script from "./CouponUsed.vue?vue&type=script&lang=js&"
export * from "./CouponUsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0eef8a",
  null
  
)

export default component.exports